import { createSlice } from '@reduxjs/toolkit'

import { fetchFilterFields } from 'common/filter/actions/filterFields'
import { parseIntegrationFields } from 'common/filter/models/AudienceFilter/adapter'

import { FilterFieldsState } from './interfaces'

export const initialState: FilterFieldsState = {
  static: [],
  custom: [],
  system: [],
  global: [],
  integration: undefined,
  error: null,
  requestId: null,
  isLoading: false,
  isLoaded: false,
}

export const filterFieldsSlice = createSlice({
  name: 'fields',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilterFields.pending, (state, action) => {
        state.isLoading = true
        state.error = null
        state.requestId = action.meta.requestId
      })
      .addCase(fetchFilterFields.fulfilled, (state, action) => {
        const { requestId } = action.meta

        if (state.requestId !== requestId) return

        const data = action.payload
        state.static = data?.static || []
        state.custom = data?.custom || []
        state.system = data?.system || []
        state.global = data?.global || []
        state.integration = parseIntegrationFields(data?.integration ?? {})
        state.error = null
        state.isLoading = false
        state.isLoaded = true
      })
      .addCase(fetchFilterFields.rejected, (state, action) => {
        const { requestId } = action.meta
        if (state.requestId !== requestId) return

        state.static = []
        state.custom = []
        state.system = []
        state.global = []
        state.integration = undefined
        state.error = action.error.message || 'Unknown error'
        state.isLoading = false
      })
  },
})
